/* src/app/components/confirm-comment-modal/confirm-comment-modal.component.scss */
ion-checkbox::part(label) {
  white-space: break-spaces;
}
h1 {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 22px;
}
p {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 16px;
}
/*# sourceMappingURL=confirm-comment-modal.component-QTIDKHX4.css.map */
